import { myAccountActions } from '../store/myAccountSlice';
import { useAppDispatch } from './store-hook';
import type { MyAccountRouteName } from '../models/NavigationElements';

export interface MyAccountActionsHook {
  navigate(routeName: MyAccountRouteName): void;
  setVisibility(visible: boolean): void;
  setProps(props: any | undefined): void;
}

const useMyAccountActions = () => {
  const dispatch = useAppDispatch();

  const navigate = (routeName: MyAccountRouteName) => {
    dispatch(myAccountActions.navigate(routeName));
  };

  const setVisibility = (visible: boolean) => {
    dispatch(myAccountActions.setVisibility(visible));
  };

  const setProps = (props: any | undefined) => {
    dispatch(myAccountActions.setProps(props));
  };

  return {
    navigate,
    setVisibility,
    setProps
  } as MyAccountActionsHook;
};

export default useMyAccountActions;
